module.exports = __webpack_public_path__ + "img/loading-black.130e56eb.svg";